export default (state, { newSkus }) => ({
  ...state,
  ...newSkus,
  isSpecialOrder: false,
});
